import "./PriestHeader.css";

const PriestHeader = ({ priest }) => {
  const { image, alt, role, name, born, prezb } = priest;

  return (
    <div className="priest-header">
      <p className="role-text">{role}</p>
      <img className="divider-elg" src="./assets/8.png" alt="Kościół"/>
      <img src={image} alt={alt} className="image-priest" title="fot. Natanael Brewczyński"/>
      <p className="priest-name">{name}</p>
      <p>ur. {born}</p>
      <p aria-label={`Święcenia prezbiteriatu ${prezb}`}>prezb. {prezb}</p>
    </div>
  );
};

export default PriestHeader;